// Import debug control FIRST to override console methods early
import './utils/debugControl';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { onUpdate } from './service-worker';
import config from './config';

if (process.env.REACT_APP_NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://204f5d32d0da49579f84790772683a86@sentry.io/2196417',
    environment: process.env.REACT_APP_NODE_ENV,
    release: `customer-app-pwa@${config.RELEASE_VER}`
  });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if (process.env.REACT_APP_NODE_ENV === 'production') {
  serviceWorker.register({ onUpdate });
} else {
  serviceWorker.unregister()
}
